import { Directive } from '@angular/core';
@Directive({
  selector: '[fSelectorContainer]',
  standalone: false
})
export class SelectorContainerDirective {}
